__turbopack_context__.v({
  "list_left": "WithChevronList-module-scss-module__PJJQcG__list_left",
  "list_right": "WithChevronList-module-scss-module__PJJQcG__list_right",
  "list_wrap": "WithChevronList-module-scss-module__PJJQcG__list_wrap",
  "with_chevron_list_over_text": "WithChevronList-module-scss-module__PJJQcG__with_chevron_list_over_text",
  "with_chevron_list_title": "WithChevronList-module-scss-module__PJJQcG__with_chevron_list_title",
});
